import {Injectable} from '@angular/core';
import {PersonenstandEnum, StammdatenPartnerschaft, StammdatenPersonenstandEnum} from '@nachdigal';
import {MappedStammdatenPartner, MappedStammdatenPartnerschaft} from '@utils-lib';
import {InlandsadresseMapperService} from './inlandsadresse-mapper.service';
import {PersonMapperService} from './person-mapper.service';
import {AuslandsadresseMapperService} from './auslandsadresse-mapper.service';
import {SteueridentifikationMapperService} from './steueridentifikation-mapper.service';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class PartnerschaftMapperService extends AbstractMapper<StammdatenPartnerschaft, MappedStammdatenPartnerschaft> {

    constructor(
        private readonly personMapper: PersonMapperService,
        private readonly inlandsadresseMapper: InlandsadresseMapperService,
        private readonly auslandsadresseMapper: AuslandsadresseMapperService,
        private readonly steueridentifikationMapper: SteueridentifikationMapperService) {
        super();
    }

    protected mapInternal(source: StammdatenPartnerschaft): MappedStammdatenPartnerschaft {
        return {
            partner: this.mapPartner(source),
            ehepartnerInlandsadressen: this.inlandsadresseMapper.mapArrayWithDefault(source.ehepartnerAdressen),
            ehepartnerAuslandsadressen: this.auslandsadresseMapper.mapArrayWithDefault(source.ehepartnerAdressen)
        };
    }

    private mapPartner(source: StammdatenPartnerschaft): MappedStammdatenPartner {
        return {
            ehepartner: this.personMapper.map(source.ehepartner),
            steueridentifikation: this.steueridentifikationMapper.map(source.ehepartner),
            personenstand: source.personenstand === StammdatenPersonenstandEnum._001 ? null : {
                personenstand: source.personenstand as PersonenstandEnum
            }
        };
    }
}
